import { IAjax } from 'lib/Ajax';
import { Typeahead, ServerSideTypeaheadParams } from '../typeahead/model';
import { TypeaheadServerSide } from '../typeahead/typeahead-server-side';

import { DomainSummary } from 'data/models/DomainSummary';

import { Entrypoints } from 'core/app/entrypoints';
import { PCCache } from 'data/PCCache';
import { NullableMeasurement } from 'data/models/Measurement';

import { VesselServiceListingData } from 'data/models/VesselServiceListing';
import { Vessel, VesselData } from 'data/models/Vessel';
import { VesselStatus } from 'server/enums/VesselStatus';
import { PendingVesselServiceListingCache } from './cache';


export interface PendingVesselServiceListingParams {
    status : VesselStatus | null;
}

export interface PendingVesselModel {
    Model : Vessel;
    OnRowClick : () => void;
}

export function PendingVesselServiceListing (
    ajax :          IAjax,
    entrypoints :   Entrypoints,
    cache :         PendingVesselServiceListingCache,
    { status } :    PendingVesselServiceListingParams
) {
    
    const key = {
        Status : status,
        SearchString : null
    };

    const   model   = cache.VesselServiceListings.update1(null, key ),
            request = ajax.Url<VesselServiceListingData>(entrypoints.VesselServiceListing(key)).Get();
 
    request.done(json => {
        cache.VesselServiceListings.update1(request.Date, json);
    });

    return {
        Model: model,
        Vessels: model.Vessels.map(VesselModel),
    };

    function VesselModel(vessel : Vessel) : PendingVesselModel {
        return {
            Model: vessel,
            OnRowClick: () => window.location.hash = '#!vesselserviceconfigure?id=' + vessel.Id()
        };
    }
}
export type PendingVesselServiceListing = ReturnType<typeof PendingVesselServiceListing>;



// WEBPACK FOOTER //
// ./apps/portcall/pendingvesselservicelisting/model.ts